// complete profile parent component, code included for - checkurl, check subdomain for opening form, cookies set for login user, custom popup for close icon.

// ..........Imports..............
import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import { connect, useSelector } from "react-redux";

// ...........CSS imports........
import "../../../assets/css/register/register.css";

// ...........Constant imports.............
import { domains } from "../../../constants/registration";

// ..........Action Imports................
import { createCurrentUrl, certificationPage, getAbsoluteDestinationUrl, IdsCheck, deviceType, setCookiesAndRedirectionOnLogin, extractKeywordFromUrl } from "../../../utils/registrationUtils";
import { gaEvent, gaLocationAndContentData } from "../../../utils/index";
import { getUserIp, getGeolocationData, postUserProfileClevertap, getUserInfo, getOneClickLoginUserCheck } from "../../../../store/slices/Registration/CommonSlices";
import {clearSignupDataResponse } from "../../../../store/slices/Registration/SignUpSlices";
// ...........Component imports...............
import Loading from "../../utils/loader";
import CommonModal from "../../utils/commonModal";
import CareersRegisterLeft from "../CareersRegisterLeft"
import logo from "../../../assets/images/register/logo.svg";
import CareersRegisterCompleteProfile from "./CareersRegisterCompleteProfile";
import axios from "axios";
import DataLayerEvents from "../../common/DataLayerEvents";
import { useDispatch } from "react-redux";
import {postUserPushToLSQ} from "../../../../store/slices/user/index"

const RegisterCompleteProfile = (props) => {
    const dispatch = useDispatch();
    // State variables
    const [domain, setDomain] = useState(null); // Domain related to the registration process
    const [open, setOpen] = useState(false); // Controls modal visibility
    const [reloadFlagOnExit, setReloadFlagOnExit] = useState(true); // Flag to reload the page on exit
    const [clevertapValues, setClevertapValues] = useState(true); // Values for Clevertap analytics
    let searchParams = window.location.search; 
    const [errorToaster, setErrorToaster] = useState(false); // set error for duplicate 
    const { oneClickLoginUserCheck : oneClickLoginUserChecks, oneClickLoginUserCheckError } = useSelector((state) => state.usersCommonData);

    // Get URL parameters
    const oneClickLocation = new URLSearchParams(searchParams)?.get("check_url");
    const cookies = new Cookies();
    let date = new Date();
    const navigate = useNavigate();
    // Cookies data for login and registration states
    const loginDataCookies = cookies?.get("loginState");
    const signupDataCookies = cookies.get("registrationState");
    const oneClickUuid = cookies?.get("one-click-login")?.data?.uuid;
    const oneClickUid = cookies?.get("one-click-login")?.data?.uid;

    // Check and validate the current URL
    const subDomainName = window.location.host?.split(".")[0];
    const urlCheck = window.location.href;
    let certificationFormCheck = searchParams?.includes("ftype=certificationform") ||
        searchParams?.includes("ftype=certification") || certificationPage(urlCheck);
    const urls = ["/user/login", "/user/complete-profile", "/user/register", "/user/otp-verify", "/user/update-profile", "user/login/otp-verify"];
    const currentDeferrerUrl = document.referrer
    const currentCookieUrl = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
    const isMatch = urls.some(path => currentDeferrerUrl?.includes(path));
    const currentUrl = isMatch ? currentCookieUrl : currentDeferrerUrl;
    // const currentUrl = document.referrer ? document.referrer : cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
    const urlObj = currentUrl ? new URL(currentUrl) : null;
    const cleanUrl = urlObj ? `${urlObj.origin}${urlObj.pathname}` : null;
    const sourseDestination = cleanUrl ? `${cleanUrl}${window.location.search}` : getAbsoluteDestinationUrl();
    const userUuid = oneClickUuid ? oneClickUuid : loginDataCookies?.userUuid;
    const googleUserUuid = loginDataCookies?.user_uuid;
    // loginDataCookies?.userUuid || loginDataCookies?.user_uuid;
    // Determine destination domain for cookies domain
    const destinationDomain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME;

    //---------------------------------------
    // Fetch user IP and set up history state on component mount
    useEffect(() => {
        if (oneClickLocation != "one_click" && !sessionStorage.getItem("loginState") && !sessionStorage.getItem("GoogleLogin")) {
            cookies.remove("loginState", {
                path: "/",
                domain: destinationDomain,
            });
            window.location.href = `/user/login${searchParams}`;
        }
        if(oneClickLocation && (googleUserUuid || userUuid)){
            let params = {};
            params.current_url = sourseDestination;
            params.user_uuid = userUuid ? userUuid : googleUserUuid;
            props.dispatch(getOneClickLoginUserCheck(params));
        }
        let user_uuid = JSON.parse(sessionStorage.getItem("loginState"))?.userUuid  || JSON.parse(sessionStorage.getItem("GoogleLogin"))?.user_uuid;
        gaEvent("signincompleteprofile", "login_signup", `${gaLocationAndContentData}`, "");
        props.dispatch(getUserIp());
        // user detail api for prefilling data
        let params = {}
        params.user_uuid = googleUserUuid || userUuid;
        params.current_url = createCurrentUrl();
        params.certification = props.domain?.id == 2 ? true : false;
        props.dispatch(getUserInfo(params));

        // Prevent back button navigation
        window.history.pushState(null, "", window.location.href);
        const handlePopstate = (event) => {

            window.location.href = cleanUrl || getAbsoluteDestinationUrl();            
            sessionStorage.clear();
            const loginState = {
                userUuid: userUuid || googleUserUuid,
                user_type: loginDataCookies?.user_type
              };
              
            cookies.set("loginState", loginState ,{
                path: "/",
                domain: window.location?.hostname?.includes("localhost") ? window.location?.hostname : destinationDomain, 
                expires: new Date(date.setDate(date.getDate() + 3)),
                sameSite: "Lax",
            });
        };
        window.onpopstate = handlePopstate;

        return () => {
            window.onpopstate = handlePopstate; // Clean up the event handler
        };

    }, []);

    // Handle various URL and cookie validations
    useEffect(() => {
        const keywordMatch = extractKeywordFromUrl(currentUrl);
        let domainVal;
        if (window.location?.hostname?.includes("localhost")) {
            const urlParams = new URLSearchParams(searchParams);
            domainVal = urlParams?.get("domain");
        } else if (keywordMatch) {
            domainVal = keywordMatch;
        } else if (certificationFormCheck || certificationPage(urlCheck)) {
            domainVal = "certification";
        } else {
            domainVal = window.location.host?.split(".")[0];
        }
        let domainObj = {};
        domainObj = domains.find((obj) => obj.name == domainVal);
        if (!domainObj) {
            domainObj = domains.find((obj) => obj.name == "www");
        }
        setDomain(domainObj);
    }, []);

    useEffect(() => {
        if(oneClickLocation && oneClickLoginUserChecks && (googleUserUuid || userUuid)){
            const uuidToSet = userUuid || googleUserUuid;
            const uuidKey = userUuid ? "userUuid" : "user_uuid";
            cookies.set("loginState", { [uuidKey]: uuidToSet, user_type: "new_user", ask_mobile_verify : oneClickLoginUserChecks?.ask_mobile_verify, cta_clicked : "one_click" }, {
            path: "/",
            expires: new Date(date.setDate(date.getDate() + 3)),
            sameSite: "Lax",
            domain: window.location?.hostname?.includes("localhost") ? window.location?.hostname : destinationDomain,
        });
        sessionStorage.setItem("loginState", JSON.stringify({ [uuidKey]: uuidToSet, user_type: "new_user", ask_mobile_verify : oneClickLoginUserChecks?.ask_mobile_verify, cta_clicked : "one_click" }));
        // window.location.href = `/user/complete-profile${window.location.search}`;
          if(!oneClickLoginUserChecks?.ask_complete_profile){

            // if (!sessionStorage.getItem("loginState") && !sessionStorage.getItem("GoogleLogin")) {
                cookies.remove("loginState", {
                    path: "/",
                    domain: destinationDomain,
                });
                window.location.href = `/user/login${searchParams}`;
            // }
          }
        }
      },[oneClickLoginUserChecks])

    // Event for preventing default browser popup on redirecting
    useEffect(() => {
        // Redirect to a specific URL if reloadFlagOnExit is false
        if (!reloadFlagOnExit) {
            if (props.signupDataError?.duplicate_user || props.signupDataError?.error == true) {
                cookies.remove("loginState", {
                    path: "/",
                    domain: destinationDomain,
                });
                sessionStorage.clear();
                if (oneClickUid) {
                    const cookieData = {
                        data: {
                            uuid: null,
                            uid: oneClickUid
                        }
                    };
                
                    cookies.set("one-click-login", cookieData, {
                        path: "/",
                        domain: window.location?.hostname?.includes("localhost") ? window.location.hostname : destinationDomain,
                        expires: new Date(date.setDate(date.getDate() + 3)),
                        sameSite: "Lax",
                    });
                } else {
                    cookies.remove("one-click-login", {
                        path: "/",
                        domain: window.location?.hostname?.includes("localhost") ? window.location.hostname : destinationDomain,
                    });
                }
                setReloadFlagOnExit(true); // for back popup reload.
                window.location.href = `/user/login${searchParams}`;
                props.dispatch(clearSignupDataResponse());
            } else {
                setReloadFlagOnExit(true); // for back popup reload.
                window.location.href = cleanUrl || getAbsoluteDestinationUrl();
            }
        }
    }, [!reloadFlagOnExit])

    // Fetch geolocation data based on user IP
    useEffect(() => {
        if (props.userIps || props.userIpError) props.dispatch(getGeolocationData({ ip: props.userIps?.ip }))
    }, [props.userIps || props.userIpError])

    // Handle cookies and other data on successful signup
    useEffect(() => {
        if(props.postSignupData){ // clearing state in case of positive response
            setErrorToaster(false);
        }
        // Check if login has proceeded
        if (props.postSignupData?.proceed == true && (props.postSignupData?.cookies || props.postSignupData?.user_session_data)) {
            // Post CleverTap events
            clevertapEvents();
            //post CleverTap user profile data
            postUserProfileClevertapData();
            // -------------- set Login session cookies -----------------
            // if (props.postSignupData?.user_id) {
            //     dispatch(postUserPushToLSQ({ user_id: props.postSignupData?.user_id }));
            // }
            // setCookiesAndRedirectionOnLogin(props.postSignupData);
            setCookiesAndRedirectionOnLogin(props.postSignupData, () =>
            dispatch(postUserPushToLSQ({ user_id: props.postSignupData?.user_id }))
            );

        }
    }, [props.postSignupData])

    useEffect(() => {
        if(props.signupDataError?.duplicate_user || props.signupDataError?.error == true){
         setErrorToaster(true);
         const timeout = setTimeout(() => {
            setErrorToaster(false);
            setReloadFlagOnExit(false);
            sessionStorage.clear();
            cookies.remove("loginState", {
                path: "/",
                domain: destinationDomain,
            });
          }, 2000);
          return () => clearTimeout(timeout);
        }
    }, [props.signupDataError])
  



    useEffect(() => {
        if(oneClickLoginUserCheckError){
            cookies.remove("one-click-login", {
                path: "/",
                domain: destinationDomain,
              });
              cookies.remove("mv_status", {
                path: "/",
                domain: destinationDomain,
              });
              cookies.remove("up_status", {
                path: "/",
                domain: destinationDomain,
              });
              cookies.remove("loginState", {
                path: "/",
                domain: destinationDomain,
              })
              cookies.remove("user-agent-key", {
                path: "/",
                domain: destinationDomain,
              });
              sessionStorage.clear(); 
              window.location.href = cleanUrl || getAbsoluteDestinationUrl();
        }
    }, [oneClickLoginUserCheckError])

    // Post user profile data to Clevertap for analytics
    const postUserProfileClevertapData = () => {
        const destinationUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
        // Retrieve login data from cookies
        const loginData = cookies.get("loginState")?.formValues;
        let obj = {};
        obj.current_url = sourseDestination;
        obj.page_url = sourseDestination;
        obj.certification = domain?.id == 2 ? true : false;
        obj.destination = destinationUrl;
        obj.email = loginData?.email || JSON.parse(sessionStorage.getItem("GoogleLogin"))?.email;
        obj.cta_clicked = cookies.get("loginState")?.cta_clicked ? cookies.get("loginState")?.cta_clicked : JSON.parse(sessionStorage.getItem("GoogleLogin")) ? "google" : "login";
        obj.country_code = "+91";
        obj.location = clevertapValues?.location?.id;
        obj.current_location = props.geolocationData?.city ? `${props.geolocationData?.city},${props.geolocationData?.state},${props.geolocationData?.country}` : "";
        obj.education_level = clevertapValues?.education_level?.id;
        obj.name = clevertapValues?.studentname?.trim();
        obj.interested_in = clevertapValues.interested_in?.length > 0 ? IdsCheck(clevertapValues?.interested_in) : [];
        obj.user_uuid = loginData?.userUuid;
        obj.user_type = loginData?.user_type;
        obj.checkbox_id = props.tertiaryChecboxData?.id ?? 0;
        obj.checkbox_status = clevertapValues?.tertiary_checkbox?.[0]?.id == 1 ? true : false;
        if (JSON.parse(sessionStorage.getItem("GoogleLogin"))) obj.mobile_number = clevertapValues?.mobile;
        if (clevertapValues?.passing_year)
            obj.passing_year = clevertapValues?.passing_year?.id;
        if (clevertapValues?.aspiring_stream)
            obj.aspiring_stream = clevertapValues?.aspiring_stream?.id;
        if (clevertapValues?.degree_pursue)
            obj.degree_pursue = clevertapValues.degree_pursue?.id;
        if (clevertapValues?.target_year)
            obj.target_year = clevertapValues.target_year?.id;
        if (clevertapValues?.work_experience)
            obj.work_experience = JSON.stringify(clevertapValues.work_experience?.id);
        if (clevertapValues?.education_interest) {
            if (clevertapValues?.education_interest?.id)
                obj.degree_interested = clevertapValues?.education_interest?.id
            if (clevertapValues?.education_interest?.group_id) {
                obj.is_group = true;
            }
            obj.domain_id = clevertapValues?.education_interest?.domain_id;
        };
        if (clevertapValues.passport?.length > 0)
            obj.passport = clevertapValues.passport?.[0]?.id;
        if (clevertapValues.course_joining_preference)
            obj.course_joining_preference = clevertapValues?.course_joining_preference?.[0]?.id;
        if (clevertapValues.area_of_interest?.length > 0)
            obj.area_of_interest = clevertapValues?.area_of_interest;
        if (clevertapValues?.country?.length > 0)
            obj.country = IdsCheck(clevertapValues?.country);
        if (clevertapValues.certificate_interest)
            obj.certificate_interest = clevertapValues.certificate_interest?.domain_id;
        obj.certification = props.domain?.id == 2 ? true : false;

        props.dispatch(postUserProfileClevertap(obj));
    };

    // Push Clevertap events for analytics
    const clevertapEvents = () => {
        gaEvent("sessioncompleteprofile", "login_signup", `${gaLocationAndContentData}`, ""); // on successful session start via login

        let clevertapEventsDataSignup = {};
        clevertapEventsDataSignup.userName = clevertapValues?.studentname;
        clevertapEventsDataSignup.userEmail = loginDataCookies?.formValues?.email || JSON.parse(sessionStorage.getItem("GoogleLogin"))?.email;
        clevertapEventsDataSignup.userMobile = loginDataCookies?.formValues?.mobile || clevertapValues?.mobile;
        clevertapEventsDataSignup.studyingIn = clevertapValues?.education_level?.label;
        clevertapEventsDataSignup.location = clevertapValues?.location?.label;
        if (clevertapValues?.education_interest || clevertapValues?.certificate_interest)
            clevertapEventsDataSignup.eduInterest = clevertapValues?.education_interest?.label || clevertapValues?.certificate_interest?.label;
        if (clevertapValues?.target_year)
            clevertapEventsDataSignup.admissionTarget = clevertapValues?.target_year?.label;
        if (clevertapValues?.passing_year) clevertapEventsDataSignup.passingYear = clevertapValues?.passing_year?.label;
        window.dataLayer.push({ ...clevertapEventsDataSignup, event: "ctsignup" });
    }
    // Handle navigation on modal confirmation
    const handleNavigate = (obj) => {
        if (obj === "yes") {
            cookies.remove("registrationState", {
                path: "/",
                domain: destinationDomain,
            });
            const loginState = {
                userUuid: userUuid || googleUserUuid,
                user_type: loginDataCookies?.user_type,
              };
              
            cookies.set("loginState", loginState ,{
                path: "/",
                domain: window.location?.hostname?.includes("localhost") ? window.location?.hostname : destinationDomain, 
                expires: new Date(date.setDate(date.getDate() + 3)),
                sameSite: "Lax",
            });
            cookies.remove("user-agent-key", {
                path: "/",
                domain: destinationDomain,
            });
            sessionStorage.clear();
            setReloadFlagOnExit(false);
        }
    }

    return (
        <div className="careers_register_main">
            {domain &&
                <>
                    {(props.postSignupData?.proceed && props.postSignupData?.cookies) ?
                        // loader
                        <div className="text-center">
                            <Loading colour={"FFA500"} size={100} />
                        </div> :
                        //Left side content page.
                        <>
                            <DataLayerEvents contentType={"Login/Signup"} pageTypes={"complete_profile"} verticalName={domain?.domain} />
                            <div className="careers_register_leftside">
                                <CareersRegisterLeft />
                            </div>
                            <div tabIndex="0" id="manage_dropdown_leftshift" className="careers_register_rightside">
                                {/* Complete profile Content page where all forms screens are visible accordingly */}
                                <CareersRegisterCompleteProfile domain={domain}
                                    reloadFlagOnExit={reloadFlagOnExit} setClevertapValues={setClevertapValues} errorToaster ={errorToaster} />
                                {/* close icon */}
                                {deviceType == "web" &&
                                    <AiOutlineClose className="close_icon" onClick={() => {
                                        setOpen(true)
                                    }} />}
                            </div></>}

                    {/* opens modal when click on close icons */}
                    <CommonModal
                        isOpen={open}
                        showCloseIcon={false}
                        closeOnOverlayClick={false}
                        closeOnEsc={false}
                        closeModal={() => {
                            setOpen(false);
                        }}
                        classNames={{ root: "continue_modal" }}
                    >
                        <div className="careers_register_modal">
                            <div className="careers_register_modal_header">
                                <img src={logo} alt="logo" />
                            </div>
                            <div className="careers_register_modal_body careers_register_modal_body_back_button">
                                <p>Wait! Your learning journey is just one step away.</p>
                                <p> By exiting , you may not be able to access resources.</p>
                                <p>Do you want to continue?</p>
                                <div className="careers_register_modal_buttons">
                                    <button onClick={() => handleNavigate("yes")} >{deviceType == "mobile" ? "No, exit" : "No, I want to Exit"}</button>
                                    <button className="careers_register_modal_button_active" onClick={() => setOpen(false)}>
                                        {deviceType == "mobile" ? "Yes, Continue" : "Yes,  I want to Continue"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </CommonModal>
                </>}
        </div>
    );
};
const mapStateToProps = (state) => {
    return {
        userIps: state.usersCommonData?.userIp,
        userIpError: state.usersCommonData?.userIpError,
        loginDatas: state.usersCommonData?.loginData,
        postSignupData: state.userSignUpFields?.signupData,
        geolocationData: state.usersCommonData?.geoLocation,
        signupDataError: state.userSignUpFields?.signupDataError
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterCompleteProfile);
